import { currentBrandReleases } from './currentReleases';

export interface LatestBrandRelease {
  id: string;
  title: string;
  subtitle: string;
  author: string;
  brand: string;
  brandSlug: string;
  category: string;
  publishDate: string;
  isbn: string;
  coverImage: string;
  summary: string;
}

export const latestBrandReleases: LatestBrandRelease[] = [
  ...currentBrandReleases,
  {
    "id": "book-9786269339341",
    "title": "大腦不喜歡你這樣學：從性格、節奏到環境，打造專屬你的最佳學習模式",
    "subtitle": "從理解大腦到認識自我，找出適合的學習方法",
    "author": "姚建明 編著",
    "brand": "策點文化",
    "brandSlug": "cedian-culture",
    "category": "科普知識",
    "publishDate": "2026-10-22",
    "isbn": "9786269339341",
    "coverImage": "/assets/books/9786269339341.jpg",
    "summary": "從理解大腦到認識自我，找出適合的學習方法 掌握學習者、引導者與媒介的關係 建立真正有效且能長久維持的學習模式"
  },
  {
    "id": "book-9786264085670",
    "title": "瞄準顧客荷包！業務員必備的銷售聖經：阿特金森教你理解不同顧客的評估方式與購買動機",
    "subtitle": "開口推銷前，先懂點心理學！",
    "author": "[美]威廉．沃克．阿特金森（William Walker Atkinson）著",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "商業理財",
    "publishDate": "2026-10-21",
    "isbn": "9786264085670",
    "coverImage": "/assets/books/9786264085670.jpg",
    "summary": "開口推銷前，先懂點心理學！ 用百年前的銷售經典，重新回答今日的成交難題 從第一次接觸到完成交易，解析每一步背後的影響因素"
  },
  {
    "id": "book-9786264085687",
    "title": "潛能大師法蘭克．哈多克的意志力法則：拖延、分心、猶豫、懶散……把自律變成本能，把目標變成結果",
    "subtitle": "【意志、思想、行動的力量】",
    "author": "[美]法蘭克．錢寧．哈多克（Frank Channing Haddock）著",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "心理學",
    "publishDate": "2026-10-21",
    "isbn": "9786264085687",
    "coverImage": "/assets/books/9786264085687.jpg",
    "summary": "【意志、思想、行動的力量】 每個人的內在，都蘊藏著無限潛能， 透過鍛鍊意志、掌握思考與培養自律，"
  },
  {
    "id": "book-9786264284608",
    "title": "有兵無糧銀，大明缺補給！帝國三百年邊防與財政危機：衛所變革×邊鎮經營×賦役失衡，從開國強盛到末世危局，解讀明朝國運轉折",
    "subtitle": "從軍糧、漕運、屯田到邊餉，",
    "author": "趙旭騰",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "人文社科",
    "publishDate": "2026-10-21",
    "isbn": "9786264284608",
    "coverImage": "/assets/books/9786264284608.jpg",
    "summary": "從軍糧、漕運、屯田到邊餉， 後勤體系如何支撐明代疆域與軍事運作？ 當補給失衡、財政承壓，"
  },
  {
    "id": "book-9786264074377",
    "title": "天下一統：歷代統一與行動韜略",
    "subtitle": "戰爭，在中國數千年歷史中始終不衰，中國歷史上經歷過數次分裂，最終又數次統一。本書分為上古、中古、近古、近世四大篇章，按時間排序，為讀者講述那些統一天下的曠世之戰。",
    "author": "肖東發 主編，鍾雙德 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-21",
    "isbn": "9786264074377",
    "coverImage": "/assets/books/9786264074377.jpg",
    "summary": "戰爭，在中國數千年歷史中始終不衰，中國歷史上經歷過數次分裂，最終又數次統一。本書分為上古、中古、近古、近世四大篇章，按時間排序，為讀者講述那些統一天下的曠世之戰。 本書特色： 本書以中國歷代統一戰爭為主軸，分為上古、中古、近古、近世四大篇章，依時間順序梳理從商湯滅夏、周武王伐商，到秦漢、三國、隋唐，以及宋、元、明、清等時期的重要戰爭。透過鳴條、牧野、長平、官渡、隋統一等戰役，呈現歷代政權由分裂走向統一的歷史進程，並兼述戰爭中的軍事謀略與戰爭藝術。"
  },
  {
    "id": "book-9786264074384",
    "title": "文武科舉：科舉歷史與選拔制度",
    "subtitle": "隋代科舉屬於初始階段，考試題目和內容都有隨意性，但開科取士這個政治措施，把讀書、應考和做官三件事緊密聯繫起來，科舉成了封建知識分子進入官場的階梯和取得高官厚祿的門路，從而改變了「上品無寒門，下品無士族」的流弊。 武則天親自策問貢士於洛城殿，開創了科舉考試中殿試的形式。武則天還令人練武習功，以長堆、馬射、馬槍等為考試內容，透過武舉來選拔軍事人才，從而開創了武舉的先例。 宋代所流行的《得意詩》： 久旱逢甘雨，他鄉見故知。洞房花燭夜，金榜掛名時。 詩中的「金榜掛名時」，便是知識分子追求功名的得意心態。",
    "author": "肖東發 主編，鍾雙德 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-21",
    "isbn": "9786264074384",
    "coverImage": "/assets/books/9786264074384.jpg",
    "summary": "隋代科舉屬於初始階段，考試題目和內容都有隨意性，但開科取士這個政治措施，把讀書、應考和做官三件事緊密聯繫起來，科舉成了封建知識分子進入官場的階梯和取得高官厚祿的門路，從而改變了「上品無寒門，下品無士族」的流弊。 武則天親自策問貢士於洛城殿，開創了科舉考試中殿試的形式。武則天還令人練武習功，以長堆、馬射、馬槍等為考試內容，透過武舉來選拔軍事人才，從而開創了武舉的先例。 宋代所流行的《得意詩》： 久旱逢甘雨，他鄉見故知。洞房花燭夜，金榜掛名時。 詩中的「金榜掛名時」，便是知識分子追求功名的得意心態。 本書特色： 本書以中國歷代人才選拔制度為主軸，從堯舜、西周、春秋戰國的求賢與選士措施談起，梳理秦漢至魏晉南北朝的選才制度，進而介紹隋唐科舉的形成與發展，以及宋、遼、金、元、明、清各代的考試與選官制度。同時兼述武舉的起源與制度，呈現中國古代從招賢納才、軍功選士到科舉取士的制度演變。"
  },
  {
    "id": "book-9786264074391",
    "title": "生物尋古：生物歷史與生物科技",
    "subtitle": "遠在人類社會初期，古人就已在從事最簡單的採集、漁獵的生產過程中，開始學會辨別一些有用和有害的動物與植物，並逐步形成了中國古代的生物分類體系。 人們辨認和品嚐各種野生動植物，從中獲得了種種經驗和知識，並以當時的方式記錄。 而寄生於其他植物生長的菌類，也被視為食療聖品。菌類種類繁多，不僅營養豐富，而且藥用價值甚高，它側面反映了中國古代文明光輝的歷史。 昆蟲則是整個生物界中最大的類群，牠們形體雖小，卻種類和數量眾多，關係著人類的生產和生活，歷代人民在昆蟲研究和害蟲防治方面都取得了顯著的成績。 明清兩代對幾千年浩如煙海的典籍文物進行了收集、訂正、考辨和編纂，成就了中國文化史上的重大貢獻。",
    "author": "肖東發 主編，余海文 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-21",
    "isbn": "9786264074391",
    "coverImage": "/assets/books/9786264074391.jpg",
    "summary": "遠在人類社會初期，古人就已在從事最簡單的採集、漁獵的生產過程中，開始學會辨別一些有用和有害的動物與植物，並逐步形成了中國古代的生物分類體系。 人們辨認和品嚐各種野生動植物，從中獲得了種種經驗和知識，並以當時的方式記錄。 而寄生於其他植物生長的菌類，也被視為食療聖品。菌類種類繁多，不僅營養豐富，而且藥用價值甚高，它側面反映了中國古代文明光輝的歷史。 昆蟲則是整個生物界中最大的類群，牠們形體雖小，卻種類和數量眾多，關係著人類的生產和生活，歷代人民在昆蟲研究和害蟲防治方面都取得了顯著的成績。 明清兩代對幾千年浩如煙海的典籍文物進行了收集、訂正、考辨和編纂，成就了中國文化史上的重大貢獻。 本書特色： 本書從遠古人類辨識、利用動植物的經驗出發，梳理中國生物知識的早期發展，依序介紹早期生物學、動植物分類、菌類與昆蟲的利用，以及明清時期的生物學成就。並透過甲骨文、《禹貢》、《莊子》等古代文獻，呈現古人對動植物、自然環境與生物資源的觀察與認識，勾勒中國生物學知識由古至今的發展脈絡。"
  },
  {
    "id": "book-9786264074407",
    "title": "戰事演義：歷代戰爭與著名戰役",
    "subtitle": "本書按照中國歷史朝代順序，分為四個篇章：上古、中古、近古、近世。上古篇為先秦以前的戰役，本書中所介紹的有：少康復國之戰、鳴條之戰、牧野之戰、長勺之戰、城濮之戰、桂陵之戰和馬陵之戰、長平之戰。中古篇為秦漢到隋唐之間，書中包含的有：鉅鹿之戰、井陘之戰、垓下之戰、漠北大戰、官渡之戰、赤壁之戰、淝水之戰、建康之戰、太原之戰。近古篇主要為兩宋時期，本書所講述的包含：澶州之戰、采石之戰、襄樊之戰、崖山海戰。近世篇是從明代到清代，有：北京保衛戰、抗倭之戰、薩爾滸戰役、平定三藩之戰、噶爾丹之戰。對於每個朝代和每場戰爭，本書全面性、綜合性地解說了當時的地理、政治、社會等背景，接著述說戰術的運用、主要領軍人物的策略等，最後分析戰役帶來的影響。可謂是一本相當豐富、精彩的中國歷代戰事大全。",
    "author": "肖東發 主編，信自力 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-21",
    "isbn": "9786264074407",
    "coverImage": "/assets/books/9786264074407.jpg",
    "summary": "本書按照中國歷史朝代順序，分為四個篇章：上古、中古、近古、近世。上古篇為先秦以前的戰役，本書中所介紹的有：少康復國之戰、鳴條之戰、牧野之戰、長勺之戰、城濮之戰、桂陵之戰和馬陵之戰、長平之戰。中古篇為秦漢到隋唐之間，書中包含的有：鉅鹿之戰、井陘之戰、垓下之戰、漠北大戰、官渡之戰、赤壁之戰、淝水之戰、建康之戰、太原之戰。近古篇主要為兩宋時期，本書所講述的包含：澶州之戰、采石之戰、襄樊之戰、崖山海戰。近世篇是從明代到清代，有：北京保衛戰、抗倭之戰、薩爾滸戰役、平定三藩之戰、噶爾丹之戰。對於每個朝代和每場戰爭，本書全面性、綜合性地解說了當時的地理、政治、社會等背景，接著述說戰術的運用、主要領軍人物的策略等，最後分析戰役帶來的影響。可謂是一本相當豐富、精彩的中國歷代戰事大全。 本書特色： 本書依中國歷史朝代順序，精選少康復國、牧野、長平、赤壁、淝水、襄樊、崖山、北京保衛戰、抗倭、平定三藩等著名戰役，從地理、政治、社會背景切入，解析戰術運用、將領策略與戰役影響，帶讀者掌握中國歷代戰爭的演變與謀略智慧。"
  },
  {
    "id": "book-9786267165577",
    "title": "猿來如此！現代人的遠古基因設定：互惠合作×群體歸屬×地位競爭×伴侶選擇……文明一路向前，人類仍帶著演化留下的本能與偏好生活！",
    "subtitle": "為什麼我們總是在意別人怎麼看自己？",
    "author": "林遠華",
    "brand": "清文華泉",
    "brandSlug": "qinghua-wenquan",
    "category": "科普知識",
    "publishDate": "2026-10-21",
    "isbn": "9786267165577",
    "coverImage": "/assets/books/9786267165577.jpg",
    "summary": "為什麼我們總是在意別人怎麼看自己？ 為什麼有些聲音、氣味和顏色特別容易吸引注意？ 人類早已離開荒野，但許多行為仍受到天性的影響"
  },
  {
    "id": "book-9786264710381",
    "title": "BMduino整合開發智慧家居長者血氧監測系統",
    "subtitle": "本書是「BMduino系列程式設計」的第四本書，主要透過筆者帶學生團隊參第二十屆盛群盃HOLTEK MCU創意大賽進入決賽的隊伍，以團隊參賽作品內容，一步一部解析系統內容，從其電路設計、韌體開發到雲端系統開發等等，轉成教學書籍來教導新手與初階使用者之讀者熟悉使用BMduino開發板完成一個完成的產品雛型開發等等。",
    "author": "曹永忠、蔡文宗、周孝興、曹慈恩、蔡宗翰、顧邦立、潘奕廷、呂佳翰、何宥慶",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "科普知識",
    "publishDate": "2026-10-21",
    "isbn": "9786264710381",
    "coverImage": "/assets/books/9786264710381.jpg",
    "summary": "本書是「BMduino系列程式設計」的第四本書，主要透過筆者帶學生團隊參第二十屆盛群盃HOLTEK MCU創意大賽進入決賽的隊伍，以團隊參賽作品內容，一步一部解析系統內容，從其電路設計、韌體開發到雲端系統開發等等，轉成教學書籍來教導新手與初階使用者之讀者熟悉使用BMduino開發板完成一個完成的產品雛型開發等等。 BMduino開發板最強大的不只是它的簡單易學的開發工具，最強大的是它網路功能與簡單易學的模組函式庫，幾乎Maker想到應用於物聯網開發的東西，只要透過眾多的周邊模組，都可以輕易的將想要完成的東西用堆積木的方式快速建立，而且BMduino開發板市售價格比原廠Arduino Yun或Arduino + Wifi Shield更具優勢，最強大的是BMduino開發板低廉的價格與Wifi與藍芽模組都可以透過外加方式擴充，更符合物聯網的基本需求，這是今年以來BMduino開發板為何這樣火熱的原因，希望透過這個系列書籍的分享，讓Maker不需要具有深厚的電子、電機與電路能力，就可以輕易駕御BMduino開發板與周邊模組。 筆者很早就開始使用BMduino開發板，也算是先驅使用者，感謝社團法人中華倍創STEAM教育發展協會與倍創科技的支持，本書才得以付梓出版，若沒有這些先進協助，本書無法付梓，所以筆者不勝感激，希望筆者可以推出更多的入門書籍給更多想要進入「BMduino開發板」、「物聯網」、「健康醫療」、「AI科技」這個未來大趨勢，所有才有這個系列的產生。"
  },
  {
    "id": "book-9786264710398",
    "title": "大承氣湯：瀉熱攻下精華",
    "subtitle": "峻下熱結、通腑泄熱、行氣除滿",
    "author": "楊建宇，伍睿昕，趙丹丹 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-21",
    "isbn": "9786264710398",
    "coverImage": "/assets/books/9786264710398.jpg",
    "summary": "峻下熱結、通腑泄熱、行氣除滿 深入解析經典名方「大承氣湯」 從經方出處、歷代方論到辨證用方與現代研究"
  },
  {
    "id": "book-9786264710404",
    "title": "癌病辨治四十年，中醫腫瘤臨床實錄：培本健脾×調整免疫×祛瘀解毒×中西醫協同，凝聚四十餘年臨床診療經驗，完整呈現常見癌症的辨治原則與醫案實踐",
    "subtitle": "從辯證到治癌，癌病辨治與醫案精粹！",
    "author": "傅華洲，石占利 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-21",
    "isbn": "9786264710404",
    "coverImage": "/assets/books/9786264710404.jpg",
    "summary": "從辯證到治癌，癌病辨治與醫案精粹！ 承古法、融新知，從中醫腫瘤學術思想到各系統癌症辨治 完整呈現肺癌、腸癌、乳癌、攝護腺癌及血液腫瘤的醫案心得"
  },
  {
    "id": "book-9786264284561",
    "title": "大宋開國誌──南征諸國與太祖定鼎：後唐內鬥×河東起兵×契丹南侵×後漢興亡……王朝輪番更替，武將與藩鎮共同塑造趙匡胤所處的亂世",
    "subtitle": "李嗣源登基、石敬瑭起兵、契丹入中原、劉知遠稱帝……",
    "author": "金綱",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "人文社科",
    "publishDate": "2026-10-14",
    "isbn": "9786264284561",
    "coverImage": "/assets/books/9786264284561.jpg",
    "summary": "李嗣源登基、石敬瑭起兵、契丹入中原、劉知遠稱帝…… 從軍閥混戰到中原重整， 「趙匡胤時代」──大宋帝國的前史由此開始！"
  },
  {
    "id": "book-9786264284578",
    "title": "多面關公，走向華夏神壇的漫漫長路：從三國名將到千年武聖，重訪關羽的生平、功過與爭議，追索後世對「關公」形象的塑造與推崇",
    "subtitle": "他是帝，是聖，是神",
    "author": "馮建國",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "人文社科",
    "publishDate": "2026-10-14",
    "isbn": "9786264284578",
    "coverImage": "/assets/books/9786264284578.jpg",
    "summary": "他是帝，是聖，是神 受萬民香火，享千年尊崇 頭枕洛陽，身臥當陽，魂歸故里"
  },
  {
    "id": "book-9786264074278",
    "title": "天文回望：天文歷史與天文科技",
    "subtitle": "中國幾千年來累積的大量天文資料已受到各國天文學家的注意，它是世界上天文學起步最早、發展最快的國家之一。就文獻數量來說，天文學可與數學並列，僅次於農學和醫學，是中國古代最發達的四門自然科學之一。 天文學最早是在古代祭祀裡出現的。上古時期科學不發達，對大自然沒有足夠的瞭解，大部分的人認為有超自然的力量存在，於是出現了神靈崇拜，而天文學就伴隨著這樣的背景出現。 而且在文字產生以前，古人就開始利用植物的生長、動物的行蹤來判斷季節、日月的變化，這是農業生產所必備的知識，由此便創造出了曆法。 在長期的發展過程中，中國古代天文學屢創出優良的曆法、令人驚豔的發明、見識卓絕的宇宙觀，這些都在世界天文學發展史上占據了重要的地位。 本書特色：本書從天象記載、曆法編訂與天文儀器三大面向，帶讀者回望中國古代天文學的發展歷程。從物候授時、星象觀測到《太初曆》、《大衍曆》、《授時曆》等重要曆法，並介紹渾儀、簡儀、渾象與水運儀象臺等經典天文儀器，呈現古人觀察天…",
    "author": "肖東發 主編，劉干才 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-14",
    "isbn": "9786264074278",
    "coverImage": "/assets/books/9786264074278.jpg",
    "summary": "中國幾千年來累積的大量天文資料已受到各國天文學家的注意，它是世界上天文學起步最早、發展最快的國家之一。就文獻數量來說，天文學可與數學並列，僅次於農學和醫學，是中國古代最發達的四門自然科學之一。 天文學最早是在古代祭祀裡出現的。上古時期科學不發達，對大自然沒有足夠的瞭解，大部分的人認為有超自然的力量存在，於是出現了神靈崇拜，而天文學就伴隨著這樣的背景出現。 而且在文字產生以前，古人就開始利用植物的生長、動物的行蹤來判斷季節、日月的變化，這是農業生產所必備的知識，由此便創造出了曆法。 在長期的發展過程中，中國古代天文學屢創出優良的曆法、令人驚豔的發明、見識卓絕的宇宙觀，這些都在世界天文學發展史上占據了重要的地位。 本書特色：本書從天象記載、曆法編訂與天文儀器三大面向，帶讀者回望中國古代天文學的發展歷程。從物候授時、星象觀測到《太初曆》、《大衍曆》、《授時曆》等重要曆法，並介紹渾儀、簡儀、渾象與水運儀象臺等經典天文儀器，呈現古人觀察天地、探索宇宙的智慧，以及中國古代天文學在世界科學史上的重要成就。"
  },
  {
    "id": "book-9786264074285",
    "title": "古往今來：歷代更替與王朝千秋",
    "subtitle": "中國朝代歷經多次更迭交替，本書以時序排列，分上古、中古、近古與近世世大篇章，這些內容包括了：春秋戰國時代的的諸侯風雲、秦漢乃至隋唐的興亡見證、五代十國至元代的政權劇變、明清兩代的王朝盛衰，為讀者呈現一部簡明的中國朝代通史概要。",
    "author": "肖東發 主編，鍾雙德 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-14",
    "isbn": "9786264074285",
    "coverImage": "/assets/books/9786264074285.jpg",
    "summary": "中國朝代歷經多次更迭交替，本書以時序排列，分上古、中古、近古與近世世大篇章，這些內容包括了：春秋戰國時代的的諸侯風雲、秦漢乃至隋唐的興亡見證、五代十國至元代的政權劇變、明清兩代的王朝盛衰，為讀者呈現一部簡明的中國朝代通史概要。 本書特色： 本書分為上古、中古、近古與近世四大篇章，涵蓋夏商周、春秋戰國、秦漢、三國、南北朝、隋唐、五代十國、宋元，以及明清等重要歷史時期，透過朝代建立、政權更替與重大歷史事件，勾勒中國數千年政治與社會發展脈絡。適合作為認識中國歷史與朝代演變的入門讀物。"
  },
  {
    "id": "book-9786264074292",
    "title": "兵器陣法：歷代軍事與兵器陣法",
    "subtitle": "本書分為兵勇、軍制、兵器、陣法四大篇章，按照朝代排序，為讀者展示中國古代的軍事歷史。",
    "author": "肖東發 主編，信自力 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-14",
    "isbn": "9786264074292",
    "coverImage": "/assets/books/9786264074292.jpg",
    "summary": "本書分為兵勇、軍制、兵器、陣法四大篇章，按照朝代排序，為讀者展示中國古代的軍事歷史。 本書特色： 從夏商周一路到明清，本書依歷史時序梳理中國古代軍事發展，從歷代兵勇、軍事制度、兵器與陣法四大面向，介紹各時代的軍隊組織、徵募制度與戰鬥方式。內容涵蓋青銅兵器、鐵製兵器、火器及攻守城器械，並介紹魚鱗陣、八卦陣、十面埋伏、騎兵五軍陣與鴛鴦陣，呈現中國古代軍事制度、兵器與戰術的演變脈絡。"
  },
  {
    "id": "book-9786264074315",
    "title": "文房四寶：紙筆墨硯及文化內涵",
    "subtitle": "毛筆歷史悠久，是中國古代主流書寫工具，它在形成的歷程中，於製作、使用方面都累積了大量的歷史經驗，是中國傳統文化的重要部分。 墨是中國古代書寫中必不可缺的用品，用這種獨創的材料，中國書畫藝術的奇妙意境才能得以實現。 紙張的發明，結束了古代簡牘繁複的時代，讓訊息的儲存和交流更方便，對於促進文化的傳播與發展、推動世界文明的發展具有劃時代的意義。 硯臺則在歷代以其不同的形式、不同的質地、不同的種類和豐富的文化內涵，構成一部豐富多彩的中國硯史。 文房四寶是構成中國古代文化的基石，無論歷史、政治、學術、書畫等都離不開它們，正是有了筆墨紙硯，才能讓這些文明歷經千百年也能傳承下去。",
    "author": "肖東發 主編，陳秀伶 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-14",
    "isbn": "9786264074315",
    "coverImage": "/assets/books/9786264074315.jpg",
    "summary": "毛筆歷史悠久，是中國古代主流書寫工具，它在形成的歷程中，於製作、使用方面都累積了大量的歷史經驗，是中國傳統文化的重要部分。 墨是中國古代書寫中必不可缺的用品，用這種獨創的材料，中國書畫藝術的奇妙意境才能得以實現。 紙張的發明，結束了古代簡牘繁複的時代，讓訊息的儲存和交流更方便，對於促進文化的傳播與發展、推動世界文明的發展具有劃時代的意義。 硯臺則在歷代以其不同的形式、不同的質地、不同的種類和豐富的文化內涵，構成一部豐富多彩的中國硯史。 文房四寶是構成中國古代文化的基石，無論歷史、政治、學術、書畫等都離不開它們，正是有了筆墨紙硯，才能讓這些文明歷經千百年也能傳承下去。 本書特色：筆墨紙硯不只是古人的書寫工具，更是中華文化傳承的重要載體。本書從毛筆、古墨、紙張與硯臺四大主題出發，梳理其起源、發展、製作工藝與文化內涵，從先秦一路介紹至明清，帶讀者認識歷代文房器物的演變與特色。從蒙恬造筆的傳說、名墨製作到名硯鑑賞，深入呈現文房四寶與中國書畫、歷史文化之間的密切關聯。"
  },
  {
    "id": "book-9786264710329",
    "title": "大柴胡湯：和解攻下名方",
    "subtitle": "和解少陽、通下裡實、表裡雙解",
    "author": "楊建宇，董昌盛，鍾丹珠 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-14",
    "isbn": "9786264710329",
    "coverImage": "/assets/books/9786264710329.jpg",
    "summary": "和解少陽、通下裡實、表裡雙解 深入解析經典名方「大柴胡湯」 從方劑源流、歷代方論到辨證用方與現代研究"
  },
  {
    "id": "book-9786264710336",
    "title": "看！這就是元素週期表：從黃金夢到人造元素，人類追尋物質祕密的漫長旅程",
    "subtitle": "小小一張週期表，真的寫下所有元素了嗎？",
    "author": "陳志謙 編著",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "科普知識",
    "publishDate": "2026-10-14",
    "isbn": "9786264710336",
    "coverImage": "/assets/books/9786264710336.jpg",
    "summary": "小小一張週期表，真的寫下所有元素了嗎？ 科學家是如何「創造」新元素？ 銫、氟、鈾……重新認識那些一碰就爆炸與不碰也爆炸的危險「分子」！"
  },
  {
    "id": "book-9786264710343",
    "title": "新手家長不慌張！兒童健康照護詳解：發燒咳嗽×腹痛腹瀉×意外傷害×成長發育，從新生兒到青春期，掌握危險警訊與就醫時機",
    "subtitle": "【從日常照護到緊急處置，陪孩子健康長大】",
    "author": "程艷波 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-14",
    "isbn": "9786264710343",
    "coverImage": "/assets/books/9786264710343.jpg",
    "summary": "【從日常照護到緊急處置，陪孩子健康長大】 孩子發燒、咳嗽、腹瀉，什麼情況需要立即就醫？ 誤吞異物、燒燙傷、溺水、骨折，第一時間該怎麼處理？"
  },
  {
    "id": "book-9786269326532",
    "title": "一葉懂茶，茶出400種知識：英國伯爵茶、阿根廷瑪黛茶、日本玄米茶、臺灣泡沫紅茶……完整認識所有名茶、茶器與茶事",
    "subtitle": "從一片茶葉出發，讀懂品種、產地、工藝與風味之間的關聯",
    "author": "王如良 主編",
    "brand": "策點文化",
    "brandSlug": "cedian-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-07",
    "isbn": "9786269326532",
    "coverImage": "/assets/books/9786269326532.jpg",
    "summary": "從一片茶葉出發，讀懂品種、產地、工藝與風味之間的關聯 由茶園走進茶席，掌握選茶、泡茶、品茶及茶文化的完整知識 ▎從一片茶葉看見完整的茶世界"
  },
  {
    "id": "book-9786264085601",
    "title": "量子科技正在改變世界，從粒子走向晶片：看懂量子科技真正改變了什麼！量子點×自旋電子×奈米探針×量子通訊×量子電腦，從百年科學理論到現代產業應用",
    "subtitle": "材料×測量×奈米科技×通訊×運算×晶片……",
    "author": "陳俊延",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "科普知識",
    "publishDate": "2026-10-07",
    "isbn": "9786264085601",
    "coverImage": "/assets/books/9786264085601.jpg",
    "summary": "材料×測量×奈米科技×通訊×運算×晶片…… 少量簡單公式， 帶你從量子原理讀到科技應用與產業發展，"
  },
  {
    "id": "book-9786264284431",
    "title": "怦怦吟・磨",
    "subtitle": "主人公雙憶因猝遭喪母之痛，悔恨交加，懷著對妻子湛曉露的強烈不滿，一次酒醉後回溯至20年前，在名為「一家馨」的十元店裡，看到了從前的自己，產生了重新設計人生的驚天計畫。",
    "author": "梁曉瓶",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "小說",
    "publishDate": "2026-10-07",
    "isbn": "9786264284431",
    "coverImage": "/assets/books/9786264284431.jpg",
    "summary": "主人公雙憶因猝遭喪母之痛，悔恨交加，懷著對妻子湛曉露的強烈不滿，一次酒醉後回溯至20年前，在名為「一家馨」的十元店裡，看到了從前的自己，產生了重新設計人生的驚天計畫。 於是在自己身旁若即若離暗中關照，從阻止女朋友賀蘭馨墮胎開始，不料因突發事件功虧一簣。而最後他無論如何也要躲開的湛曉露，卻在這個時空裡不可避免地與他再次重逢，讓他徹底發飆…… 萬分錯愕中，遂悟出人生的情境多會重現，卻不可抗拒地重蹈覆轍。而他抱以歉疚的賀蘭馨竟自始至終在他身邊……故事一波三折，高潮迭起，令人久久不能釋卷。"
  },
  {
    "id": "book-9786264284547",
    "title": "《尚書》與華夏之始，政治、歷史與諸學源流：溯源文明×解讀經典×鑑古知今，從王朝更替看思想、禮制與社會秩序的建立",
    "subtitle": "堯舜禪讓，是千古傳頌的美談，還是被改寫的權力交接？",
    "author": "錢宗武，王鋒",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "人文社科",
    "publishDate": "2026-10-07",
    "isbn": "9786264284547",
    "coverImage": "/assets/books/9786264284547.jpg",
    "summary": "堯舜禪讓，是千古傳頌的美談，還是被改寫的權力交接？ 翻開《尚書》，從最早的文字紀錄追索華夏文明的真相 ▎華夏典籍的文明源頭"
  },
  {
    "id": "book-9786267866351",
    "title": "富春山居圖，畫中之蘭亭：走進古代文人的精神世界，探索六百年傳世經典的技法與意境",
    "subtitle": "一卷山水，藏盡黃公望筆下的天地與人生",
    "author": "趙洪波",
    "brand": "沐燁文化",
    "brandSlug": "muye-culture",
    "category": "人文社科",
    "publishDate": "2026-10-07",
    "isbn": "9786267866351",
    "coverImage": "/assets/books/9786267866351.jpg",
    "summary": "一卷山水，藏盡黃公望筆下的天地與人生 循著富春江徐徐展卷，讀懂中國山水畫的千年意境 ▎一卷山水，展開中國畫的觀看之道"
  },
  {
    "id": "book-9786264074209",
    "title": "化學歷程：化學歷史與化學科技",
    "subtitle": "化學技術早在遠古時期就已融入人類的生活，許多看似尋常的工藝其實都和化學的智慧息息相關。",
    "author": "肖東發 主編，方士華 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "科普知識",
    "publishDate": "2026-10-07",
    "isbn": "9786264074209",
    "coverImage": "/assets/books/9786264074209.jpg",
    "summary": "化學技術早在遠古時期就已融入人類的生活，許多看似尋常的工藝其實都和化學的智慧息息相關。 陶器，在古代是不可缺少的日用品，是人類生活跨入新石器時期的標誌之一，同時也是第一種利用化學手段創造出的人工製品。 冶金，是人類由使用石器、陶器進入到使用金屬的里程碑，隨著冶煉技術的發展和提高，更促進了社會文明的進步。"
  },
  {
    "id": "book-9786264074216",
    "title": "天下奇石：賞石文化與藝術特色",
    "subtitle": "中國自古有靈石崇拜，各代文人雅士都愛玩賞石頭，常有人蒐集溝買珍奇的石頭至傾家盪產。 傳說女媧以五彩石補天、大禹由靈石所生，白居易曾作〈太湖詩〉，蘇東坡有〈雪浪石〉，黃庭堅作〈劉晦叔洮河綠石研〉……不僅如此，徐霞客、曹雪芹、鄭板橋、趙孟頫、蒲松齡都愛石，且多有著述。 甚至常有人蒐集購買珍奇的石頭至傾家盪產，據說明代米萬鍾，曾為了運送一塊大石，先修路，又打井，花了不知多少錢，將石頭運到半途，財力便耗盡了，只好丟棄路邊，這塊大石從此被叫做「敗家石」，直到清時，乾隆西陵祭祖歸途中，才將這塊大石運回皇家園林。 石的魅力，石的故事，石的文化，五千年的歷史，一一為你展現──",
    "author": "肖東發 主編，鹿軍士 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-07",
    "isbn": "9786264074216",
    "coverImage": "/assets/books/9786264074216.jpg",
    "summary": "中國自古有靈石崇拜，各代文人雅士都愛玩賞石頭，常有人蒐集溝買珍奇的石頭至傾家盪產。 傳說女媧以五彩石補天、大禹由靈石所生，白居易曾作〈太湖詩〉，蘇東坡有〈雪浪石〉，黃庭堅作〈劉晦叔洮河綠石研〉……不僅如此，徐霞客、曹雪芹、鄭板橋、趙孟頫、蒲松齡都愛石，且多有著述。 甚至常有人蒐集購買珍奇的石頭至傾家盪產，據說明代米萬鍾，曾為了運送一塊大石，先修路，又打井，花了不知多少錢，將石頭運到半途，財力便耗盡了，只好丟棄路邊，這塊大石從此被叫做「敗家石」，直到清時，乾隆西陵祭祖歸途中，才將這塊大石運回皇家園林。 石的魅力，石的故事，石的文化，五千年的歷史，一一為你展現── 本書特色： 從遠古靈石崇拜、女媧補天神話，到隋唐造景、宋元清供與明清賞石風潮，本書梳理中國賞石文化五千年流變，帶你讀懂奇石背後的信仰、美學與文人雅趣。"
  },
  {
    "id": "book-9786264074230",
    "title": "歷史開關：千年古城牆與古城門",
    "subtitle": "城牆，是中國古代城市的傳統防禦設施，是由牆體和其他輔助軍事設施構成的軍事防線。古代農耕民族在應對戰爭時，會使用土木、磚石等材料，在都邑四周建起的用作防禦的障礙性建築，由牆體和附屬設施構成封閉型區域。本書中所要介紹的明清城牆有：集城池建造大全的南京城牆、見證古老歷史的西安城牆、有第一城池美譽的襄陽城牆、攻而不破的荊州城牆、建方形衛城的興城古城城牆、兼具防水功能的臨海城牆、有眾多傳說的壽縣城牆、承前啟後的典範鳳陽城牆、形似古錢的商丘古城牆。城門，是建立在古代城池四周的門，多數城牆外圍還有護城河，正對城門處設有可以隨時起落的吊橋，吊橋一升起，進出城的通路便被截斷。人們進出城池，必須從城門經過，因此城門口大多設有警衛，遇有緊急狀態，則封閉城門，禁止通行。在古代，攻城都必需攻打城門，所以是極為重要的防禦和守衛建築。本書介紹的城門則包含：拱衛京師的皇城內九城門、北京外七城門和皇城四門、歷史古城西安的城門、古城南京禦敵屏障的中華門、人間天堂杭…",
    "author": "肖東發 主編，周廣雙 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-07",
    "isbn": "9786264074230",
    "coverImage": "/assets/books/9786264074230.jpg",
    "summary": "城牆，是中國古代城市的傳統防禦設施，是由牆體和其他輔助軍事設施構成的軍事防線。古代農耕民族在應對戰爭時，會使用土木、磚石等材料，在都邑四周建起的用作防禦的障礙性建築，由牆體和附屬設施構成封閉型區域。本書中所要介紹的明清城牆有：集城池建造大全的南京城牆、見證古老歷史的西安城牆、有第一城池美譽的襄陽城牆、攻而不破的荊州城牆、建方形衛城的興城古城城牆、兼具防水功能的臨海城牆、有眾多傳說的壽縣城牆、承前啟後的典範鳳陽城牆、形似古錢的商丘古城牆。城門，是建立在古代城池四周的門，多數城牆外圍還有護城河，正對城門處設有可以隨時起落的吊橋，吊橋一升起，進出城的通路便被截斷。人們進出城池，必須從城門經過，因此城門口大多設有警衛，遇有緊急狀態，則封閉城門，禁止通行。在古代，攻城都必需攻打城門，所以是極為重要的防禦和守衛建築。本書介紹的城門則包含：拱衛京師的皇城內九城門、北京外七城門和皇城四門、歷史古城西安的城門、古城南京禦敵屏障的中華門、人間天堂杭州的護城壁壘、古都洛陽的堅實城門。 本書特色： 從南京、西安到荊州、興城，走入明清城牆與天下城門的攻防世界。看護城河、箭樓、敵樓與城門如何構成古城防線，讀懂中國城池建造的智慧、歷史與傳說。"
  },
  {
    "id": "book-9786264074308",
    "title": "教育之本：歷代官學與民風教化",
    "subtitle": "【從文明初曙到儒學奠基】",
    "author": "肖東發 主編，鍾雙德 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-07",
    "isbn": "9786264074308",
    "coverImage": "/assets/books/9786264074308.jpg",
    "summary": "【從文明初曙到儒學奠基】 教育不僅是知識與技藝的傳授，更是形塑社會秩序、倫理觀念與民族精神的重要力量。本書從上古時期的生活經驗與五氏授技談起，探討早期先民如何藉由勞動、生產及群體生活，逐步形成教育的雛形；並透過堯舜時期的教化實踐，以及夏、商、周三代官學制度的建立，呈現教育由日常傳習走向制度化的歷程。隨著禮樂文明日益成熟，教育開始肩負維繫政治秩序與培養人才的功能。到了春秋戰國，官學衰微、私學興起，諸子百家競相講學，使學術與教育突破身份限制。尤其儒家重視仁義、禮樂、修身與德行，奠定中國古代道德教化的核心，也深刻影響後世教育理念。 【官學建制與教化傳承】"
  },
  {
    "id": "book-9786264710251",
    "title": "李守先《針灸易學》校注本：二十二日治癒437人，清代針灸醫家的臨床心得與學針之道",
    "subtitle": "「針灸難不在穴，在手法耳！」",
    "author": "[清]李守先 著高希言，高崚 校注",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-07",
    "isbn": "9786264710251",
    "coverImage": "/assets/books/9786264710251.jpg",
    "summary": "「針灸難不在穴，在手法耳！」 清代針灸名家李守先的五十年臨床實踐之作。 ▎《針灸易學》為清代針灸醫家李守先（字善述，西元1735－1819）所著，成書於嘉慶三年（1798年）。李守先出身河南長葛，無名師傳授，全憑自學苦讀六年，後於五十一歲時因瘧疾流行機緣開始臨床施針，二十二天內治癒437人，此後行醫十餘年，「回生起疴至於千百」。他有感當時針灸典籍「古奧難窺……句不可讀，讀不可記」，遂執筆撰成這部簡明讀本，冀「廣其傳，以登斯世於仁壽之域」。"
  },
  {
    "id": "book-9786264710268",
    "title": "空腹斷食養身，讓身體「適度挨餓」！斷食原理、代謝機制、營養補充、細胞自噬……認識空腹與斷食的運作機制，重新建立健康飲食新生活！",
    "subtitle": "空腹，是身體的另一種休息！",
    "author": "莊建彬",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-07",
    "isbn": "9786264710268",
    "coverImage": "/assets/books/9786264710268.jpg",
    "summary": "空腹，是身體的另一種休息！ 脂肪代謝×免疫調節×細胞修復…… 理解常見斷食方式，搭配營養、運動與生活習慣，"
  },
  {
    "id": "book-9786264710275",
    "title": "國王的遊戲：成王敗寇",
    "subtitle": "或者戴上王冠，或者人頭落地",
    "author": "馬瑞民",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "人文社科",
    "publishDate": "2026-10-07",
    "isbn": "9786264710275",
    "coverImage": "/assets/books/9786264710275.jpg",
    "summary": "或者戴上王冠，或者人頭落地 真實致命的權力鬥爭，中古歐洲的三國演義 英格蘭長期以來一直都在發瘋。"
  },
  {
    "id": "book-9786264710282",
    "title": "排溼名方茵陳蒿湯",
    "subtitle": "清熱利溼、通利二便、利膽退黃",
    "author": "楊建宇，倪青，楊敏 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-07",
    "isbn": "9786264710282",
    "coverImage": "/assets/books/9786264710282.jpg",
    "summary": "清熱利溼、通利二便、利膽退黃 深入解析經典名方「茵陳蒿湯」 從方劑源流、歷代方論到辨證用方與現代研究"
  }
];

export function getLatestBrandReleases(brandSlug: string): LatestBrandRelease[] {
  return latestBrandReleases.filter((book) => book.brandSlug === brandSlug);
}

